import { useStyles } from './styles';
import { RateImportStatusEnum } from '@/main/services/enum/RateImportStatusEnum';

interface IStatusBodyshopRateProps {
  idStatus: RateImportStatusEnum,
  name: string
}

export default function StatusBodyshopRate({ idStatus, name }: IStatusBodyshopRateProps) {
  const classes = useStyles();

  const renderColor = () => {
    switch (idStatus) {
      case RateImportStatusEnum.Success:
        return '#00cc66';
      case RateImportStatusEnum.Error:
        return '#e41414';
      default:
        return '#949494';
    }
  };
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${classes.container}`}
      title={name}
      style={{ backgroundColor: renderColor() }}
    >
      <span className={classes.spanContainer}>{name}</span>
    </div>
  );
}
